import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { TableVirtuoso, TableComponents } from 'react-virtuoso';
import { Box, Dialog, DialogContent, DialogTitle, Tooltip, Typography } from '@mui/material';
import { TransformFilters } from '.';
import { calcularDiferencaEmMeses } from '../../../../helpers/calcularDiferencaEmMeses';

const columns = [
    "codigo",
    "nome",
    "qtd_vendas",
    "qtd_vendas_sazonal",
    "estoque_atual",
    "nivel",
]

export default function DetalheDialog({
    open,
    handleClose,
    items = [],
    filters
}: DetalheDialogProps) {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth={"lg"}
            fullWidth={true}
        >
            <DialogTitle>{items.length} Item(s)</DialogTitle>
            <DialogContent>
                <Box style={{ height: 800, width: '100%' }}>
                    <TableVirtuoso
                        data={items}
                        components={VirtuosoTableComponents}
                        fixedHeaderContent={() => fixedHeaderContent({filters})}
                        itemContent={rowContent}
                    />
                </Box>
            </DialogContent>
        </Dialog >
    );
}


const VirtuosoTableComponents: TableComponents = {
    Scroller: React.forwardRef<HTMLDivElement>((props, ref) => (
        <TableContainer {...props} ref={ref} />
    )),
    Table: (props) => (
        <Table {...props} />
    ),
    TableHead: (props) => (
        <TableHead {...props} sx={{
            position: 'fixed',
            top: 0,
            backgroundColor: 'white',
            zIndex: 100
        }} />
    ),
    TableRow: ({ item: _item, ...props }) => <TableRow {...props} />,
    TableBody: React.forwardRef<HTMLTableSectionElement>((props, ref) => (
        <TableBody {...props} ref={ref} />
    )),
};

function fixedHeaderContent({filters}: THeaderProps) {
    return (
        <React.Fragment>
            <TableRow>
                <TableCell rowSpan={2} sx={{ fontWeight: 'bold' }}>Código</TableCell>
                <TableCell rowSpan={2} sx={{ fontWeight: 'bold', width: 400 }}>Produto</TableCell>
                <TableCell colSpan={2} sx={{ fontWeight: 'bold', border: 0 }}>Qtd. total de vendas</TableCell>
                <TableCell rowSpan={2} sx={{ fontWeight: 'bold' }}>Estoque atual</TableCell>
                <TableCell rowSpan={2} sx={{ fontWeight: 'bold' }}>Nível do estoque</TableCell>
            </TableRow>
            <TableRow>
                <TableCell sx={{minWidth: 90}}>
                    <Typography component={Box} variant="caption">Período</Typography>
                    <Typography component={Box} variant="caption">{calcularDiferencaEmMeses(filters.periodo_inicio, filters.periodo_fim)} meses</Typography>
                    </TableCell>
                <TableCell sx={{minWidth: 82}}>
                    <Typography component={Box} variant="caption">Sazonal</Typography>
                    <Typography component={Box} variant="caption">{calcularDiferencaEmMeses(filters.sazonalidade_inicio, filters.sazonalidade_fim)} meses</Typography>
                    </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

function rowContent(index: number, row: any) {

    return (
        <React.Fragment>
            {columns.map((column) => {
                let rowValue = row[column]

                if (column === "qtd_vendas_sazonal") {
                    rowValue =
                        <Tooltip title={`${Math.ceil(row['qtd_vendas_sazonal_media_diaria'] * 100) / 100} por dia`}>
                            {row?.["qtd_vendas_sazonal"] ? row?.["qtd_vendas_sazonal"].split('.')[0] : "0"}
                        </Tooltip>
                }
                if (column === "qtd_vendas") {
                    rowValue =
                        <Tooltip title={`${Math.ceil(row["qtd_vendas_media_diaria"] * 100) / 100} por dia`}>
                            {row?.["qtd_vendas_media_mensal"] ? row?.["qtd_vendas"].split('.')[0] : "0"}
                        </Tooltip>
                }
                if (column === "nivel") {
                    rowValue = `${Math.ceil(row[column] * 10) / 10} dia(s)`
                }

                return (
                    <TableCell
                        key={index}
                        align={typeof row[column] === "number" ? 'center' : 'left'}
                    >
                        {rowValue}
                    </TableCell>
                )
            })}
        </React.Fragment>
    );
}


interface DetalheDialogProps {
    open: boolean,
    handleClose: () => void;
    items: Array<any>
    filters: TransformFilters
}

interface THeaderProps {
    filters: TransformFilters
}
